<template>
  <input
    v-model="model"
    :type="type"
    class="st-control"
    :class="{ 'st-control--shell': onShell, 'st-control--mono': mono }"
  />
</template>

<script setup lang="ts">
const model = defineModel<string>();
withDefaults(
  defineProps<{
    type?: string;
    onShell?: boolean;
    /** Render in the monospace face (ids, codes). */
    mono?: boolean;
  }>(),
  { type: 'text' },
);
</script>
